import { SwarovskiPageData } from "@swo/storefront";

export function readInitialPageDataForPath(path: string): SwarovskiPageData | undefined {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
  const maybePageData = (window as any)?.pageData;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (maybePageData && maybePageData.forPath === path && maybePageData.data) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
    return maybePageData.data;
  } else {
    return undefined;
  }
}
